import React, { Fragment } from 'react';
import { shape, string, object } from 'prop-types';
import { Segment, Button } from 'semantic-ui-react';

import Heading from '~/views/common/Heading';
import Section from '~/views/common/Section';
import DataTable from '~/views/common/DataTable';
import BoolIcon from '~/views/common/BoolIcon';
import { Tab } from 'semantic-ui-react';

import Login from './Login';
import FeatureFlags from './FeatureFlags';

const UserTabGeneral = ({
    data: {
        id,
        name,
        primary_email,
        feature_flags,
        created,
        modified,
        birthdate,
        postal_code,
        gender,
        product,
        slug,
        deleted,
        archived,
        wants_email,
        wants_newsletter,
        wants_sms,
    },
    ssoData, // Ensure this prop is destructured
}) => (
    <Tab.Pane>
        <Segment.Group>
            <Section name="Info">
                <DataTable.Body>
                    <DataTable.Row header="ID">{ id }</DataTable.Row>
                    <DataTable.Row header="Product">{ product }</DataTable.Row>

                    <DataTable.Row header="Slug">{ slug }</DataTable.Row>
                    <DataTable.Row header="Gender">{ gender }</DataTable.Row>
                    <DataTable.Row header="Postal Code">{ postal_code }</DataTable.Row>
                    <DataTable.Row header="Birthdate">{ birthdate }</DataTable.Row>
                    <DataTable.Row header="Created">{ created }</DataTable.Row>
                    <DataTable.Row header="Modified">{ modified }</DataTable.Row>
                    <DataTable.Row header="Deleted"><BoolIcon value={deleted} /></DataTable.Row>
                    <DataTable.Row header="Archived"><BoolIcon value={archived} /></DataTable.Row>
                    <DataTable.Row header="Wants Email"><BoolIcon value={wants_email} /></DataTable.Row>
                    <DataTable.Row header="Wants Sms"><BoolIcon value={wants_sms} /></DataTable.Row>
                    <DataTable.Row header="Wants Newsletter"><BoolIcon value={wants_newsletter} /></DataTable.Row>
                </DataTable.Body>
            </Section>
            <Login primary_email={{ ...primary_email, sso_data: ssoData }} />
            <FeatureFlags feature_flags={feature_flags} />
        </Segment.Group>
    </Tab.Pane>
);

UserTabGeneral.propTypes = {
    data: shape({
        id: string.isRequired,
        name: string.isRequired,
        primary_email: object.isRequired,
        feature_flags: object.isRequired,
    }).isRequired,
    ssoData: object,
};

export { UserTabGeneral };

